import { isTest } from "./utils/environment.js";
const uuid = () => {
  if (isTest()) {
    return "test";
  }
  return "bxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/[x]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
};
const uuidUtils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uuid,
  uuid
}, Symbol.toStringTag, { value: "Module" }));
export {
  uuidUtils as a,
  uuid as u
};
//# sourceMappingURL=uuid.js.map
